"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateProductsFavourites = void 0;
const StatePaged_1 = require("../../classes/states/abstracts/StatePaged");
const BreadCrumb_1 = require("../../classes/models/BreadCrumb");
const PageProductsFavourites_1 = require("../../classes/com/PageProductsFavourites");
const AppPM_1 = require("../AppPM");
class StateProductsFavourites extends StatePaged_1.StatePaged {
    // private _productIds:number[]=[];
    // private _skip=0;
    constructor() {
        super(PageProductsFavourites_1.PageProductsFavourites, "Избранные товары", true);
        // this.page.ctrls.cmpFilterLine.hide();
        // this.page.ctrls.cmpPagination.ctrls.btnNext.onclick=()=>this._loadNextAsync();
    }
    start() {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        return __awaiter(this, void 0, void 0, function* () {
            AppPM_1.AppPM.GUI.setBreadcrumbs([new BreadCrumb_1.BreadCrumb("Главная", "/"), new BreadCrumb_1.BreadCrumb(this.title, `/${StateProductsFavourites.StateName}`)]);
            this.page.loadAsync();
            //this._searchAsync();
            return _super.start.call(this);
        });
    }
}
exports.StateProductsFavourites = StateProductsFavourites;
StateProductsFavourites.StateName = "products_favourites";
//# sourceMappingURL=StateProductsFavourites.js.map